import $ from 'jquery';
import Util from "./Util";

function setCurrentWorkout(){
	var activityArray = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	var activityArrayAll = JSON.parse(localStorage.getItem('userData')).sessionData.scriptDetail;
	
	if ( !JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId ) 
		{
			for ( let i = 0; i < activityArray.length; i++ )
				{
					if ( activityArray[i]['attribute'][0]['attrValue'] == 'Pause' || activityArray[i]['attribute'][0]['attrValue'] == 'Pause Virtual' )
						{
							activityArray.splice(i, 1);
							i--;
						}
				}
		}
	if ( activityArray.length === 0 )
		{
			$('#participant_activity').removeClass('d-none');
			$('#currentWorkout').addClass('d-none');
			$('.top_activity').addClass('top_activity_radius');
		}
	
		
	var currentActivity = {};
	var activityBefore = {};
	var currentIndex = -1;
	window.currentIndex = -1;
	window['globalCurrentIndex'] = 0;
	window['allIndexGlobal'] = 0;
	window['mainIntervalWorkout'] = null;
	window['globalTimeTimer'] = 0;
	var isPausedActivity = false;
	var rememberTimer = 0;
	var isRunningScript = false;
	var activityStarted = false;
	var currentUserData = JSON.parse(localStorage.getItem("userData"));
	var activityStarted = false;
	window.checkRTMtimeout = 0;
	var startActivityTimeout1 = 0;
	var startActivityTimeout2 = 0;
	 
	function showActivity(timeRemaining){
		$('#workout_progress').addClass('d-none');
		let lastActivity = false;
		if ( currentIndex == (activityArrayAll.length-1) )
			{
				lastActivity = true;
			}
		
		console.log('showActivity activityArrayAll', activityArrayAll);
		console.log('showActivity currentIndex', currentIndex);
		currentActivity = activityArrayAll[currentIndex];
		console.log('showActivity currentActivity', currentActivity);
		if ( currentActivity.attribute[1] && currentActivity.attribute[1].attrValue === 'Time' )
			{
				window['timerRemainingMember'] = currentActivity.attribute[2].attrValue;
			}
		else 
			{
				window['timerRemainingMember'] = currentActivity.attribute[3].attrValue * currentActivity.attribute[9].attrValue;
			}
		
		activityBefore = activityArrayAll[currentIndex - 1];
		var currentName = currentActivity.name;
		if ( currentActivity.attribute && currentActivity.attribute[12] && currentActivity.attribute[12].attrValue ) { currentName = currentActivity.attribute[12].attrValue; }
		console.log('showActivity currentActivity', currentName);
		let act_type = activityArrayAll[currentIndex]['attribute'][0]['attrValue'];
		$('#participant_activity').removeClass('d-none');
		$('#currentWorkout').text(currentName);
		
		$('.one_activity_menu').removeClass('active');
		for ( let i = 0; i < activityArrayAll.length; i++ )
			{
				if ( i < currentIndex )
					{
						$('#workout'+activityArrayAll[i].id).addClass('active');
					}
			}
				console.log('showActivity allowReadyGo', window['allowReadyGo']);
		
		if ( currentUserData && currentUserData.sessionData && currentUserData.sessionData.workoutSoundStart && rememberTimer == 0 )
				{
					let startSound = currentUserData.sessionData.workoutSoundStart;
					let startParam = '';
					if ( startSound == "Bell sound" ) { startParam = "bell"; }
					if ( startSound == "Ding" ) { startParam = "ding"; }
					if ( startSound == "Go" ) { startParam = "go"; }
					if ( startSound == "3, 2, 1" ) { startParam = "count321"; }
					if ( startSound == "All done" ) { startParam = "allDone"; }
					
					if ( window['playScriptSound'] )
						{
							window['playScriptSound'](startParam);
						}
				}
		
		if ( ((window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured) || window.userCameraOff) && window['allowReadyGo'] && ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) )
			{
				console.log('showActivity playReadySet', window['playReadySet']);
				
				if ( window['userWhiteboard'][currentUserData.id] && !window.userCameraOff ) { window['userWhiteboard'][currentUserData.id].doActivityEvents('activityStarting'); }
				
				if ( window.mediaPipeRoomSetupFail )
					{
						window.mediaPipeLastTry = true;
					}
				
				if ( !currentUserData.sessionData.ondemandId )
					{
						if ( $('.memberSide_fm_holder') )
							{
								$('.memberSide_fm_holder').addClass('hideFmOnMember');
							}
						window['hideFeedFmStatus'] = true;
					}
				
				//if ( window['userCameraOff'] && !currentUserData.sessionData.ondemandId ) { $('#canvasWrap').addClass('d-none'); }
				
				//window['updateStateFromChild']({openMyStream: false});
				
				if ( window['openParticipantList'] )
					{
						window['hideMembersOnVirtualActivity']();
						window['hideMemberOnVirtual'] = true;
						if ( !window['showAllElementsStatus'] )
							{
								$('#participants_streams').addClass('opacityHide');			
							}
					}
				
				var actIndex = window['allIndexGlobal'];
				
				var timeoutTimeAct = 1000;
				
				if ( actIndex > 0 && currentUserData.sessionData.scriptDetail && currentUserData.sessionData.scriptDetail[actIndex-1] && currentUserData.sessionData.scriptDetail[actIndex-1]['attribute'][0]['attrValue'] )
					{
						var lastActIndex = actIndex - 1;
						var lastActType = currentUserData.sessionData.scriptDetail[lastActIndex]['attribute'][0]['attrValue'];
						timeoutTimeAct = 250;
					}
				
				if ( window.detectionDisabled )
					{
						$('.virtualDisabledMsg').removeClass('d-none');
					}
					
				if ( window['deviceNotSupported'+currentUserData.id] )
					{
						$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none');
					}
					
				let startTimer = parseInt(currentActivity.attribute[2].attrValue);
				startActivityTimeout1 = setTimeout(function() {
					window.setCurrentIndexAndPause(currentIndex, startTimer);
					startActivityTimeout2 = setTimeout(function(){
						window['allowReadyGo'] = false;
						window.setCurrentIndexAndPlay(currentIndex, startTimer);
					}, timeoutTimeAct);
				}, timeoutTimeAct);
			}
		else if ( act_type !== 'Virtual Equipment' && act_type !== 'Virtual Assistant' )
			{
				window['allowReadyGo'] = false;
				
				$('.virtualDisabledMsg').addClass('d-none');
				
				if ( window['deviceNotSupported'+currentUserData.id] )
					{
						$('#virtualmsg').text('').addClass('d-none');
					}
				
				
				if ( window['hideMemberOnVirtual'] )
					{
						window['hideMemberOnVirtual'] = false; 
						window['hideMembersOnVirtualActivity']();
						$('#participants_streams').removeClass('opacityHide');				
					}					
			}
			
		if ( window['deviceNotSupported'+currentUserData.id] && ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) )
			{
				$('#virtualmsg').text('Virtual Activity Not Supported on this Device').removeClass('d-none');
			}
			
		if ( !window.closedStreamByClick )
			{
				window['updateStateFromChild']({openMyStream: true});
				$('#mine_stream').removeClass('opacityHide');
			}

		var timerCount = '00:00';
		var video;
		var timer;
		if ( !isPausedActivity ) { $('#workout_progress').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 0;'}); }
		console.log(window['allowReadyGo'], 'allowReadyGo');
		if ( currentActivity.attribute[1] && currentActivity.attribute[1].attrValue === 'Time' && !window['allowReadyGo'] )
			{
				$('#reps_counter').addClass('d-none');
				$('#time_counter').removeClass('d-none');
				
				isRunningScript = true;
				timer = parseInt(currentActivity.attribute[2].attrValue);
				window['globalTimeTimer'] = timer;
				if ( !window.userCameraOff && !currentUserData.sessionData.ondemandId ) { window.pauseVirtualActivityStarted = false; }
				if ( isPausedActivity && !window['pausedBeforeVirtual'] ) 
					{ 
						timer = rememberTimer; 
						window['timerRemainingMember'] = timer;
						isPausedActivity = false; 
						console.log(timer, 'timer_info TIME PAUSED'); 
					}
				if ( timeRemaining ) 
					{ 
						
						timer = timeRemaining; 
						window['timerRemainingMember'] = timeRemaining;					
					}
				if ( window['pausedBeforeVirtual'] ) { isPausedActivity = false; window['pausedBeforeVirtual'] = false; }
				let soundPlayed = false;
				window['scriptStarted'] = true;
				window['mainIntervalWorkout'] = setInterval(function(){
					window['allowReadyGo'] = false;
					window.isPaused = false;
					timer--;
					
					if ( window['utcTimeMember'] && window['timerRemainingMember'] ) 
						{
							timer = window['timerRemainingMember'] - (Util.getUTCTimestamp() - window['utcTimeMember']);
						}
					
					window['globalTimeTimer'] = timer;
					
					if ( timer > 0 )
						{
							let currentUserData = JSON.parse(localStorage.getItem('userData'));
							
							if ( timer < 4 && currentUserData.isMarketplaceChannel == 1 && currentUserData.sessionData && currentUserData.sessionData.workoutSoundEnd == '3, 2, 1 - No sound' ) 
								{
									$('#partBigCounter').removeClass('d-none');
									$('#partCounterNum').text(timer);
								}
							else if ( timer < 4 && currentUserData.isMarketplaceChannel == 1 && currentUserData.sessionData && currentUserData.sessionData.workoutSoundEnd == '3, 2, 1' && soundPlayed == false )
								{
									let sound = currentUserData.sessionData.workoutSoundEnd;
									let param = '';
									if ( sound == "3, 2, 1" ) { param = "count321"; }
									if ( currentUserData.sessionData.workoutSoundEnd == '3, 2, 1' && window['playScriptSound'] )
										{
											window['playScriptSound'](param);
											soundPlayed = true;
										}
								}								
							else 
								{
									$('#partBigCounter').addClass('d-none');
								}								
							timerCount = getTimerFormat(timer);
							activityStarted = true;
						}
					else
						{
							if ( $('.memberSide_fm_holder') )
								{
									$('.memberSide_fm_holder').removeClass('hideFmOnMember');
								}
							window['hideFeedFmStatus'] = false;	
							if ( currentUserData && currentUserData.sessionData && currentUserData.sessionData.workoutSoundEnd && soundPlayed == false )
								{
									let sound = currentUserData.sessionData.workoutSoundEnd;
									let param = '';
									if ( sound == "Bell sound" ) { param = "bell"; }
									if ( sound == "Ding" ) { param = "ding"; }
									if ( sound == "Go" ) { param = "go"; }
									if ( sound == "3, 2, 1" ) { param = "count321"; }
									if ( sound == "All done" ) { param = "allDone"; }
									
									if ( currentUserData.sessionData.workoutSoundEnd != '3, 2, 1 - No sound' && window['playScriptSound'] )
										{
											window['playScriptSound'](param);
										}
								}
							
							timerCount = '00:00';
							
							$('#partBigCounter').addClass('d-none');
							$('#partCounterNum').text(0);
							
							clearInterval(window['mainIntervalWorkout']);
							window['scriptStarted'] = false;
							window.isPaused = true;
							isRunningScript = false;
							if ( window['userWhiteboard'][currentUserData.id] && activityStarted && ( act_type == 'Virtual Equipment' || act_type == 'Virtual Assistant' ) && !window.userCameraOff )
								{
									window['userWhiteboard'][currentUserData.id].doActivityEvents('activityEnded', 'act_end');
									activityStarted = false;
								}
							
							if ( currentActivity && currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' )
								{
									if ( currentActivity.attribute[7] && parseInt(currentActivity.attribute[7].attrValue) == 1 )
										{
											clearInjectedVideo();
										}								
								}
							
							if ( lastActivity )
								{ 
									if ( act_type != 'Virtual Equipment' && act_type != 'Virtual Assistant' )
										{	
											setTimeout(function(){
												clearInjectedVideo();
											}, 1000);
										}
										
									$('#workout'+activityArrayAll[currentIndex].id).addClass('active');
									
									if ( !window.closedStreamByClick )
										{
											window['updateStateFromChild']({openMyStream: true});
											$('#mine_stream').removeClass('opacityHide');
										}
									//window['updateStateFromChild']({openReactions: true}); 
								}							
							
							let activityWaitTime = currentUserData.default.waitTimeAfterRegular;
							if ( act_type == 'Virtual Equipment' )
								{
									activityWaitTime = currentUserData.default.waitTimeAfterVirtual;
								}
							
							let checkTimeoutTime = activityWaitTime + currentUserData.default.nextActivityTimeout;
							
							window.checkRTMtimeout = setTimeout(function() {
								var sep = '~@$';
								if ( window['globalRTM'] && currentUserData['sessionData'] ) { window['globalRTM'](currentUserData['sessionData']['hostEmail'], 'checkActivityRTM'+sep); }
							}, checkTimeoutTime);
						}
					
					$('#workout_progress').removeClass('d-none');
					$('#workoutTimer').text(timerCount);
					rememberTimer = timer;
					
					setPercent(currentActivity.attribute[2].attrValue, timer);
				}, 1000);
			}
		
		if ( currentActivity.attribute[1] && currentActivity.attribute[1].attrValue === 'Reps' && !window['allowReadyGo'] )
			{
				$('#time_counter').addClass('d-none');
				$('#reps_counter').removeClass('d-none');
				
				isRunningScript = true;
				var repeatNum = parseInt(currentActivity.attribute[3].attrValue);
				var repeatSeconds = parseInt(currentActivity.attribute[9].attrValue);
				var fullSecondsRepeat = repeatNum * repeatSeconds;
				timer = repeatNum * repeatSeconds;
				if ( isPausedActivity ) { timer = rememberTimer; isPausedActivity = false; }
				if ( timeRemaining ) { timer = timeRemaining; }
				timerCount = getTimerFormat(timer);
				$('#workoutTimerRepeat').text(timerCount);
				$('#repeatNumber').text(repeatNum);
				window['mainIntervalWorkout'] = setInterval(function(){ 
					timer--;
					var repeatNumberCurrent = parseInt(currentActivity.attribute[3].attrValue) -  Math.floor(timer /  parseInt(currentActivity.attribute[9].attrValue));
					var repeatNumberLeft = (repeatNum - repeatNumberCurrent) + 1;
					$('#repeatNumber').text(repeatNumberLeft);
					if ( timer > 0 )
						{
							timerCount = getTimerFormat(timer);
						}
					else
						{
							$('#repeatNumber').text(0);
							timerCount = '00:00';
							clearInterval(window['mainIntervalWorkout']);
							isRunningScript = false;
							
							if ( currentActivity && currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' )
								{
									if ( currentActivity.attribute[7] && parseInt(currentActivity.attribute[7].attrValue) == 1 )
										{
											clearInjectedVideo();
										}
								}
							
							if ( lastActivity )
								{ 
									setTimeout(function(){
										clearInjectedVideo();
									}, 1000);
									
									$('#workout'+activityArrayAll[currentIndex].id).addClass('active');
									//window['updateStateFromChild']({openReactions: true}); 
								}
						}
						
					$('#workout_progress').removeClass('d-none');
					$('#workoutTimerRepeat').text(timerCount);
					rememberTimer = timer;
					
					setPercent(fullSecondsRepeat, timer);
				}, 1000);
			}
		
		if ( currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' && ( !window['hasConeScript'] || ( window['hasConeScript'] && window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.viewCaptured ) ) )
			{
				let currentUserData = JSON.parse(localStorage.getItem('userData'));
				//injected video
				video = $('#injected_video video')[0];
				video.src = currentActivity.attribute[4].attrValue;
				
				video.oncanplay = function ()
					{
						if ( currentUserData.isMarketplaceChannel == 1 )
							{	
								return false;
							}
							
						video.play();
						$('#host_stream').addClass('d-none');
						$('#injected_video, #injected_pip').removeClass('d-none');
						setPipVideo(1);
					}
				
				
				video.onended = function(e) {
					if ( currentActivity.attribute[7] && parseInt(currentActivity.attribute[7].attrValue) == 1 )
						{
							if ( currentUserData.isMarketplaceChannel == 1 )
								{	
									return false;
								}
							
							video.play();
						}
					else 
						{
							clearInjectedVideo();
						}						
				}
			}
		else
			{
				if ( activityBefore && activityBefore.attribute[4] && activityBefore.attribute[4].attrValue != '' ) 
					{ 
						var videoInj = $('#injected_video video')[0];
						if ( videoInj && $('#host_stream').hasClass('d-none') )
							{
								clearInjectedVideo();	
							}
						 
					}
				
			}	
	}
	
	function setPercent(fullTime, currentTime){
		var percent = (parseInt(currentTime) / parseInt(fullTime)) * 92;
		var percent2 = parseInt(currentTime) / parseInt(fullTime);
		var percentWidth = (92 - percent);
		$('#workout_progress').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: '+percentWidth+';'});
	}
	
	function clearInjectedVideo(){
		console.log('closeInjectedVideo');
		var videoInj = $('#injected_video video')[0];
		if ( $('#host_stream').hasClass('d-none') )
			{
				$('#injected_video, #injected_pip').addClass('d-none');
				$('#host_stream').removeClass('d-none');
			}
		
		if ( videoInj )
			{
				videoInj.pause();
				videoInj.src = '';
			}
		window['setPipStream'](0);	
	}
	
	function setPipVideo(mod){
		window['setPipStream'](mod);
	}
	
	function getTimerFormat(duration){
		// Hours, minutes and seconds
		var hrs = ~~(duration / 3600);
		var mins = ~~((duration % 3600) / 60);
		var secs = ~~duration % 60;

		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";

		if (hrs > 0) 
			{
				ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
				$('#workoutTimer').addClass('smaller_timer');
			}
		else
			{
				$('#workoutTimer').removeClass('smaller_timer');
			}
			
		if ( mins == 0 ) { mins = "0"+mins };
		
		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
	window['getTimerFormat'] = getTimerFormat;
	
	window.setCurrentActivity = (nextAct, pauseAct, indexNum, remainingTime) => {
	
		if ( nextAct && window['mainIntervalWorkout'] )
			{
				clearInterval(window['mainIntervalWorkout']);
				isPausedActivity = false;
			}

		if ( isRunningScript && !nextAct ) { return false; }
		if ( !isPausedActivity || nextAct ) 
			{ 
				if ( indexNum )
					{
						currentIndex = indexNum;
						window.currentIndex = indexNum;
					}
				else 
					{
						currentIndex++; 
						window.currentIndex++;
					}					
				 
			}
				console.log('setCurrentActivity currentIndex after', currentIndex);
		
		if ( currentIndex == activityArrayAll.length ) 
			{ 
				if ( indexNum )
					{
						currentIndex = indexNum;
						window.currentIndex = indexNum;
					}
				else 
					{
						currentIndex = -1;
						window.currentIndex = -1;
						return false;
					}					
				
			}
		
		if ( pauseAct )
			{
				if ( indexNum )
					{
						currentIndex = indexNum;
						window.currentIndex = indexNum;
					}
				else 
					{
						isPausedActivity = true;
						isRunningScript = false;
						return false;
					}					
				
			}
		console.log('showActivity remainingTime', remainingTime);
		if ( remainingTime ) { showActivity(remainingTime); }
		else { showActivity(); }
	} 
	
	window.pauseCurrentActivity = () => {
		isPausedActivity = true;
		isRunningScript = false;
		clearInterval(window['mainIntervalWorkout']);
		window['scriptStarted'] = false;
		window.isPaused = true;
		
		var videoInj = $('#injected_video video')[0];
		if ( videoInj )
			{
				setTimeout(function(){ videoInj.pause(); }, 2000);
			}
	}
	
	window.stopCurrentActivity = () => {
		isPausedActivity = false;
		isRunningScript = false;
		clearInterval(window['mainIntervalWorkout']);
		window['scriptStarted'] = false;
		window.isPaused = false;
		currentIndex = -1;
		window.currentIndex = -1;
		rememberTimer = 0;
		$('#participant_activity').addClass('d-none');
		$('.one_activity_menu').removeClass('active');
		$('#partBigCounter').addClass('d-none');
		$('#partCounterNum').text(0);
		window.stopScriptVirtual();
		if ( startActivityTimeout1 ) { clearTimeout(startActivityTimeout1); }
		if ( startActivityTimeout2 ) { clearTimeout(startActivityTimeout2); }
		if ( currentActivity && currentActivity.attribute && currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' ) { clearInjectedVideo(); }
	}
	
	window.stopScriptVirtual = () => {
		$('#canvasWrap').addClass('d-none');
		
		if ( window['userWhiteboard'][currentUserData.id] ) 
			{
				window['userWhiteboard'][currentUserData.id].resetCanvas();
				window['userWhiteboard'][currentUserData.id].globalActType = ''; 
				window.changeGlobalActType('', parseInt(currentUserData.id));
			}
			
		if ( window['userWhiteboard'][currentUserData.sessionData.hostId] ) 
			{
				window['userWhiteboard'][currentUserData.sessionData.hostId].globalActType = ''; 
				window.changeGlobalActType('', parseInt(currentUserData.sessionData.hostId));
			}
	
		if ( !window.closedStreamByClick )
			{
				window['updateStateFromChild']({openMyStream: true});
				$('#mine_stream').removeClass('opacityHide');
			}
			
		if ( window['hideMemberOnVirtual'] )
			{
				window['hideMemberOnVirtual'] = false;
				window['hideMembersOnVirtualActivity']();
			}	
			
		$('.virtualDisabledMsg').addClass('d-none');
		
		if ( window['deviceNotSupported'+currentUserData.id] )
			{
				$('#virtualmsg').text('').addClass('d-none');
			}
	}
	
	window.showActivityEnded = () => {
		isPausedActivity = false;
		isRunningScript = false;
		clearInterval(window['mainIntervalWorkout']);
		window['scriptStarted'] = false;
		window.isPaused = false;
		currentIndex = -1;
		window.currentIndex = -1;
		rememberTimer = 0;
		$('.one_activity_menu').removeClass('active');
		if ( currentActivity.attribute[4] && currentActivity.attribute[4].attrValue != '' ) { clearInjectedVideo(); }
		
		var lastIndex = activityArrayAll.length-1;
		
		var lastActivity = activityArrayAll[lastIndex];
		var lastActName = lastActivity.name;
		if ( lastActivity.attribute && lastActivity.attribute[12] && lastActivity.attribute[12].attrValue ) { lastActName = lastActivity.attribute[12].attrValue; }
		$('#participant_activity').removeClass('d-none');
		$('#currentWorkout').text(lastActName);
		
		if ( lastActivity.attribute[1] && lastActivity.attribute[1].attrValue == 'Reps' )
			{
				$('#time_counter').addClass('d-none');
				$('#reps_counter').removeClass('d-none');
				$('#repeatNumber').text(0);
				$('#workoutTimerRepeat').text('00:00');
			}
		else
			{
				$('#reps_counter').addClass('d-none');
				$('#time_counter').removeClass('d-none');
				$('#workoutTimer').text('00:00');
				$('#workout_progress').attr({'style': '--progress-bar-width:6px;--progress-color:#121126;--progress-percent: 100;'});
			}
	}
	
	window.setCurrentIndexAndPlay = (index, timeRemaining, utcTime) => {
		if ( window['mainIntervalWorkout'] ) { clearInterval(window['mainIntervalWorkout']); window['mainIntervalWorkout'] = null; }
		currentIndex = index;
		window.currentIndex = index;
		window['utcTimeMember'] = utcTime;
		window['timerRemainingMember'] = timeRemaining;
		console.log('setCurrentIndexAndPlay index', index);
		showActivity(timeRemaining);
	}
	
	window.setCurrentIndexAndPause = (index, timeRemaining, turnOfPause?) => {
		currentIndex = index;
		window.currentIndex = index;
		isPausedActivity = true;
		if ( turnOfPause )
			{
				isPausedActivity = false;
			}
		isRunningScript = false;
		clearInterval(window['mainIntervalWorkout']);
		window['scriptStarted'] = false;
		window.isPaused = true;
		var currentActivityPaused = activityArrayAll[currentIndex];
		if ( currentActivityPaused )
			{
				var currentActivityName = currentActivityPaused.name;
				if ( currentActivityPaused.attribute && currentActivityPaused.attribute[12] && currentActivityPaused.attribute[12].attrValue ) { currentActivityName = currentActivityPaused.attribute[12].attrValue; }
				$('#participant_activity').removeClass('d-none');
				$('#currentWorkout').text(currentActivityName);
				var timerCount = getTimerFormat(timeRemaining);
				var fullSeconds = parseInt(currentActivityPaused.attribute[2].attrValue);
				
				if ( currentActivityPaused.attribute[1] && currentActivityPaused.attribute[1].attrValue === 'Reps' )
					{
						$('#time_counter').addClass('d-none');
						$('#reps_counter').removeClass('d-none');
						var repeatNumberCurrent = parseInt(currentActivityPaused.attribute[3].attrValue) -  Math.floor(timeRemaining /  parseInt(currentActivityPaused.attribute[9].attrValue));
						var repeatNumLeft = (parseInt(currentActivityPaused.attribute[3].attrValue) - repeatNumberCurrent) + 1;
						$('#repeatNumber').text(repeatNumLeft);
						$('#workoutTimerRepeat').text(timerCount);
					}
				else
					{
						$('#reps_counter').addClass('d-none');
						$('#time_counter').removeClass('d-none');
						$('#workoutTimer').text(timerCount);
						setPercent(fullSeconds, timeRemaining);
					}
					
				rememberTimer = timeRemaining;	
			}
	}
	
	window.checkActivityStop = () => {
		if ( $('#currentWorkout').is(":visible") )
			{
				window.stopCurrentActivity();
			}
	}
	
	window.setPauseVirtualActName = (actName) => {
		$('#currentWorkout').text('Demo ' + actName);
	}
}

export default setCurrentWorkout;